module.exports = __webpack_public_path__ + "img/claim.30efda06.png";